const authority = {
  admin: 0,
  teacher: 1,
  parent: 2,
};

export const userMockData = [
  {
    id: 1,
    pw: "123az!!!!",
    name: "농담곰1",
    email: "1nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19700111",
    creditCardNum: "5678-9090-1212-3636",
    authority: authority.admin,
  },
  {
    id: 2,
    pw: "123az",
    name: "농담곰1",
    email: "2nong@gmail.com",
    address: "2[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19800112",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.teacher,
  },
  {
    id: 3,
    pw: "123az",
    name: "농담곰1",
    email: "3nong@gmail.com",
    address: "3[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19880113",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 4,
    pw: "123az",
    name: "농담곰4",
    email: "4nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19700114",
    creditCardNum: "5678-9090-1212-3636",
    authority: authority.admin,
  },
  {
    id: 5,
    pw: "123az",
    name: "농담곰5",
    email: "5nong@gmail.com",
    address: "5[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19800115",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.teacher,
  },
  {
    id: 6,
    pw: "123az",
    name: "농담곰6",
    email: "6nong@gmail.com",
    address: "6[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19880116",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 7,
    pw: "123az",
    name: "농담곰7",
    email: "7nong@gmail.com",
    address: "7[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19701207",
    creditCardNum: "5678-9090-1212-3636",
    authority: authority.parent,
  },
  {
    id: 8,
    pw: "123az",
    name: "농담곰8",
    email: "8nong@gmail.com",
    address: "8[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19500508",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.teacher,
  },
  {
    id: 9,
    pw: "123az",
    name: "농담곰9",
    email: "9nong@gmail.com",
    address: "9[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 10,
    pw: "123az",
    name: "농담곰10",
    email: "10nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19700111",
    creditCardNum: "5678-9090-1212-3636",
    authority: authority.admin,
  },
  {
    id: 11,
    pw: "123az",
    name: "농담곰11",
    email: "11nong@gmail.com",
    address: "2[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19800112",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.teacher,
  },
  {
    id: 12,
    pw: "123az",
    name: "농담곰12",
    email: "12nong@gmail.com",
    address: "3[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19880113",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 13,
    pw: "123az",
    name: "농담곰13",
    email: "13nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19700114",
    creditCardNum: "5678-9090-1212-3636",
    authority: authority.admin,
  },
  {
    id: 14,
    pw: "123az",
    name: "농담곰14",
    email: "14nong@gmail.com",
    address: "14[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19800115",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.teacher,
  },
  {
    id: 15,
    pw: "123az",
    name: "농담곰15",
    email: "15nong@gmail.com",
    address: "15[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19880116",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 16,
    pw: "123az",
    name: "농담곰16",
    email: "16nong@gmail.com",
    address: "16[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19701207",
    creditCardNum: "5678-9090-1212-3636",
    authority: authority.admin,
  },
  {
    id: 17,
    pw: "123az",
    name: "농담곰17",
    email: "17nong@gmail.com",
    address: "17[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19500508",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.teacher,
  },
  {
    id: 18,
    pw: "123az",
    name: "농담곰18",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 19,
    pw: "123az",
    name: "농담곰18",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 20,
    pw: "123az",
    name: "농담곰18",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 21,
    pw: "123az",
    name: "농담곰18",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 22,
    pw: "123az",
    name: "농담곰18",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 23,
    pw: "123az",
    name: "농담곰18",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 24,
    pw: "123az",
    name: "농담곰18",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 25,
    pw: "123az",
    name: "농담곰18",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 26,
    pw: "123az",
    name: "농담곰18",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 27,
    pw: "123az",
    name: "농담곰27",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 28,
    pw: "123az",
    name: "농담곰1",
    email: "1nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19700111",
    creditCardNum: "5678-9090-1212-3636",
    authority: authority.admin,
  },
  {
    id: 29,
    pw: "123az",
    name: "농담곰1",
    email: "2nong@gmail.com",
    address: "2[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19800112",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.teacher,
  },
  {
    id: 30,
    pw: "123az",
    name: "농담곰1",
    email: "3nong@gmail.com",
    address: "3[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19880113",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 31,
    pw: "123az",
    name: "농담곰4",
    email: "4nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19700114",
    creditCardNum: "5678-9090-1212-3636",
    authority: authority.admin,
  },
  {
    id: 32,
    pw: "123az",
    name: "농담곰5",
    email: "5nong@gmail.com",
    address: "5[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19800115",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.teacher,
  },
  {
    id: 33,
    pw: "123az",
    name: "농담곰6",
    email: "6nong@gmail.com",
    address: "6[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19880116",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 34,
    pw: "123az",
    name: "농담곰7",
    email: "7nong@gmail.com",
    address: "7[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19701207",
    creditCardNum: "5678-9090-1212-3636",
    authority: authority.parent,
  },
  {
    id: 35,
    pw: "123az",
    name: "농담곰8",
    email: "8nong@gmail.com",
    address: "8[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19500508",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.teacher,
  },
  {
    id: 36,
    pw: "123az",
    name: "농담곰9",
    email: "9nong@gmail.com",
    address: "9[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 37,
    pw: "123az",
    name: "농담곰10",
    email: "10nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19700111",
    creditCardNum: "5678-9090-1212-3636",
    authority: authority.admin,
  },
  {
    id: 38,
    pw: "123az",
    name: "농담곰11",
    email: "11nong@gmail.com",
    address: "2[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19800112",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.teacher,
  },
  {
    id: 39,
    pw: "123az",
    name: "농담곰12",
    email: "12nong@gmail.com",
    address: "3[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19880113",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 40,
    pw: "123az",
    name: "농담곰13",
    email: "13nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19700114",
    creditCardNum: "5678-9090-1212-3636",
    authority: authority.admin,
  },
  {
    id: 41,
    pw: "123az",
    name: "농담곰14",
    email: "14nong@gmail.com",
    address: "14[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19800115",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.teacher,
  },
  {
    id: 42,
    pw: "123az",
    name: "농담곰15",
    email: "15nong@gmail.com",
    address: "15[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19880116",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 43,
    pw: "123az",
    name: "농담곰16",
    email: "16nong@gmail.com",
    address: "16[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19701207",
    creditCardNum: "5678-9090-1212-3636",
    authority: authority.admin,
  },
  {
    id: 44,
    pw: "123az",
    name: "농담곰17",
    email: "17nong@gmail.com",
    address: "17[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19500508",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.teacher,
  },
  {
    id: 45,
    pw: "123az",
    name: "농담곰18",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 46,
    pw: "123az",
    name: "농담곰18",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 47,
    pw: "123az",
    name: "농담곰18",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 48,
    pw: "123az",
    name: "농담곰18",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 49,
    pw: "123az",
    name: "농담곰18",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 50,
    pw: "123az",
    name: "농담곰18",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 51,
    pw: "123az",
    name: "농담곰18",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 52,
    pw: "123az",
    name: "농담곰18",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 53,
    pw: "123az",
    name: "농담곰18",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 54,
    pw: "123az",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 55,
    pw: "123az",
    name: "농담곰1",
    email: "1nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19700111",
    creditCardNum: "5678-9090-1212-3636",
    authority: authority.admin,
  },
  {
    id: 56,
    pw: "123az",
    name: "농담곰1",
    email: "2nong@gmail.com",
    address: "2[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19800112",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.teacher,
  },
  {
    id: 57,
    pw: "123az",
    name: "농담곰1",
    email: "3nong@gmail.com",
    address: "3[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19880113",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 58,
    pw: "123az",
    name: "농담곰4",
    email: "4nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19700114",
    creditCardNum: "5678-9090-1212-3636",
    authority: authority.admin,
  },
  {
    id: 59,
    pw: "123az",
    name: "농담곰5",
    email: "5nong@gmail.com",
    address: "5[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19800115",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.teacher,
  },
  {
    id: 60,
    pw: "123az",
    name: "농담곰6",
    email: "6nong@gmail.com",
    address: "6[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19880116",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 61,
    pw: "123az",
    name: "농담곰7",
    email: "7nong@gmail.com",
    address: "7[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19701207",
    creditCardNum: "5678-9090-1212-3636",
    authority: authority.parent,
  },
  {
    id: 62,
    pw: "123az",
    name: "농담곰8",
    email: "8nong@gmail.com",
    address: "8[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19500508",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.teacher,
  },
  {
    id: 63,
    pw: "123az",
    name: "농담곰9",
    email: "9nong@gmail.com",
    address: "9[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 64,
    pw: "123az",
    name: "농담곰10",
    email: "10nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19700111",
    creditCardNum: "5678-9090-1212-3636",
    authority: authority.admin,
  },
  {
    id: 65,
    pw: "123az",
    name: "농담곰11",
    email: "11nong@gmail.com",
    address: "2[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19800112",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.teacher,
  },
  {
    id: 66,
    pw: "123az",
    name: "농담곰12",
    email: "12nong@gmail.com",
    address: "3[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19880113",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 67,
    pw: "123az",
    name: "농담곰13",
    email: "13nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19700114",
    creditCardNum: "5678-9090-1212-3636",
    authority: authority.admin,
  },
  {
    id: 68,
    pw: "123az",
    name: "농담곰14",
    email: "14nong@gmail.com",
    address: "14[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19800115",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.teacher,
  },
  {
    id: 69,
    pw: "123az",
    name: "농담곰15",
    email: "15nong@gmail.com",
    address: "15[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19880116",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 70,
    pw: "123az",
    name: "농담곰16",
    email: "16nong@gmail.com",
    address: "16[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19701207",
    creditCardNum: "5678-9090-1212-3636",
    authority: authority.admin,
  },
  {
    id: 71,
    pw: "123az",
    name: "농담곰17",
    email: "17nong@gmail.com",
    address: "17[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19500508",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.teacher,
  },
  {
    id: 72,
    pw: "123az",
    name: "농담곰18",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 73,
    pw: "123az",
    name: "농담곰18",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 74,
    pw: "123az",
    name: "농담곰18",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 75,
    pw: "123az",
    name: "농담곰18",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 76,
    pw: "123az",
    name: "농담곰18",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 77,
    pw: "123az",
    name: "농담곰18",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 78,
    pw: "123az",
    name: "농담곰18",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 79,
    pw: "123az",
    name: "농담곰18",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 80,
    pw: "123az",
    name: "농담곰18",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 81,
    pw: "123az",
    name: "농담곰81",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 82,
    pw: "123az",
    name: "농담곰1",
    email: "1nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19700111",
    creditCardNum: "5678-9090-1212-3636",
    authority: authority.admin,
  },
  {
    id: 83,
    pw: "123az",
    name: "농담곰1",
    email: "2nong@gmail.com",
    address: "2[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19800112",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.teacher,
  },
  {
    id: 84,
    pw: "123az",
    name: "농담곰1",
    email: "3nong@gmail.com",
    address: "3[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19880113",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 85,
    pw: "123az",
    name: "농담곰4",
    email: "4nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19700114",
    creditCardNum: "5678-9090-1212-3636",
    authority: authority.admin,
  },
  {
    id: 86,
    pw: "123az",
    name: "농담곰5",
    email: "5nong@gmail.com",
    address: "5[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19800115",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.teacher,
  },
  {
    id: 87,
    pw: "123az",
    name: "농담곰6",
    email: "6nong@gmail.com",
    address: "6[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19880116",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 88,
    pw: "123az",
    name: "농담곰7",
    email: "7nong@gmail.com",
    address: "7[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19701207",
    creditCardNum: "5678-9090-1212-3636",
    authority: authority.parent,
  },
  {
    id: 89,
    pw: "123az",
    name: "농담곰8",
    email: "8nong@gmail.com",
    address: "8[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19500508",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.teacher,
  },
  {
    id: 90,
    pw: "123az",
    name: "농담곰9",
    email: "9nong@gmail.com",
    address: "9[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 91,
    pw: "123az",
    name: "농담곰10",
    email: "10nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19700111",
    creditCardNum: "5678-9090-1212-3636",
    authority: authority.admin,
  },
  {
    id: 92,
    pw: "123az",
    name: "농담곰11",
    email: "11nong@gmail.com",
    address: "2[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19800112",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.teacher,
  },
  {
    id: 93,
    pw: "123az",
    name: "농담곰12",
    email: "12nong@gmail.com",
    address: "3[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19880113",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 94,
    pw: "123az",
    name: "농담곰13",
    email: "13nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19700114",
    creditCardNum: "5678-9090-1212-3636",
    authority: authority.admin,
  },
  {
    id: 95,
    pw: "123az",
    name: "농담곰14",
    email: "14nong@gmail.com",
    address: "14[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19800115",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.teacher,
  },
  {
    id: 96,
    pw: "123az",
    name: "농담곰15",
    email: "15nong@gmail.com",
    address: "15[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19880116",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 97,
    pw: "123az",
    name: "농담곰16",
    email: "16nong@gmail.com",
    address: "16[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19701207",
    creditCardNum: "5678-9090-1212-3636",
    authority: authority.admin,
  },
  {
    id: 98,
    pw: "123az",
    name: "농담곰17",
    email: "17nong@gmail.com",
    address: "17[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "19500508",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.teacher,
  },
  {
    id: 99,
    pw: "123az",
    name: "농담곰18",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 100,
    pw: "123az",
    name: "농담곰18",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 101,
    pw: "123az",
    name: "농담곰18",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 102,
    pw: "123az",
    name: "농담곰18",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 103,
    pw: "123az",
    name: "농담곰18",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 104,
    pw: "$2a$08$8QTvmuv74dTktsg3Hz7OlOKSEtMNsR2fEEvI9ScYjFN8W1.xG7ELC",
    name: "농담곰18",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 105,
    pw: "$2a$08$8QTvmuv74dTktsg3Hz7OlOKSEtMNsR2fEEvI9ScYjFN8W1.xG7ELC",
    name: "농담곰18",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 106,
    pw: "$2a$08$8QTvmuv74dTktsg3Hz7OlOKSEtMNsR2fEEvI9ScYjFN8W1.xG7ELC",
    name: "농담곰18",
    email: "18nong@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 107,
    pw: "$2a$08$8QTvmuv74dTktsg3Hz7OlOKSEtMNsR2fEEvI9ScYjFN8W1.xG7ELC",
    name: "농담곰18",
    email: "teacher@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.teacher,
  },
  {
    id: 108,
    pw: "$2a$08$8QTvmuv74dTktsg3Hz7OlOKSEtMNsR2fEEvI9ScYjFN8W1.xG7ELC",
    name: "농담곰108",
    email: "parents@gmail.com",
    address: "[01231]경기도 성남시 수정구 5001",
    dateOfBirth: "880912",
    creditCardNum: "1234-1234-1234-1234",
    authority: authority.parent,
  },
  {
    id: 109,
    authority: authority.admin,
    email: "admin@gmail.com",
    pw: "$2a$08$8QTvmuv74dTktsg3Hz7OlOKSEtMNsR2fEEvI9ScYjFN8W1.xG7ELC",
    name: "관리자",
    address: "[06161]서울 강남구 선릉로 520 (삼성동, 선릉빌딩)",
    detailAddress: "위코드",
    creditCardNum: "1234-1234-1234-1234",
    dateOfBirth: "990101",
  },
];
